/** OpenAI's duration-billed full-duplex voice model. */
export const OPENAI_GPT_LIVE_MODEL = 'gpt-live-1';

/** Published session price: $0.05/minute, billed by the second. */
export const OPENAI_GPT_LIVE_COST_PER_SECOND = 0.05 / 60;

interface GptLiveCostResult {
  amount?: { value?: number | string | null };
  quantity?: number | string | null;
  unit?: string | null;
}

export function isOpenAiGptLiveModel(value: string | null | undefined): boolean {
  return typeof value === 'string'
    && /^gpt-live-1(?:$|-)/i.test(value.trim());
}

/**
 * Read the authoritative Costs API amount. A quantity fallback is used only
 * when OpenAI explicitly labels it as seconds; an unlabelled quantity must not
 * be mistaken for tokens, requests, or another billable unit.
 */
export function parseOpenAiGptLiveCost(result: GptLiveCostResult): number | null {
  const amount = Number(result.amount?.value);
  if (result.amount?.value !== undefined && result.amount?.value !== null
      && Number.isFinite(amount) && amount >= 0) {
    return amount;
  }

  const normalizedUnit = result.unit?.trim().toLowerCase();
  const quantity = Number(result.quantity);
  if ((normalizedUnit === 'duration_seconds' || normalizedUnit === 'seconds')
      && result.quantity !== undefined && result.quantity !== null
      && Number.isFinite(quantity) && quantity >= 0) {
    return quantity * OPENAI_GPT_LIVE_COST_PER_SECOND;
  }

  return null;
}
